<template>
    <div 
        class="tabs-card"
        v-bind="attrs"
    >
        <div class="tabs-card__cover">
            <img
                class="tabs-card__img"
                :src="`/static/landing/${slugify(slide.title)}.jpg`"
                :loading="activeTab !== index ? 'lazy' : 'eager'"
                alt=""
            >
        </div>
        <div class="tabs-card__text">
            <small class="subtitle--small subtitle--upper">{{ slide.title }}</small>
            <h2 class="title title--light">{{ slide.body }}</h2>
    
            <router-link
                v-for="(el, x) in slide.circles"
                :aria-label="`Learn more about ${el.text}`"
                class="more more--slide"
                :to="href(el.text, el.media)"
                :key="x + el.text"
                v-bind="{ tabindex: a11y ? attrs.tabindex : -1 }"
            >
                <span class="more__label">Learn more</span>
                <span class="more__icon"><i /></span>
            </router-link>
        </div>

    </div>
</template>

<script>
import { adjustSlugFromTitle, adjustStorySlugByPath } from '@/mixins/lib/textFormat'

export default {
    props: {
        a11y: {
            type: Boolean,
            default: true
        },
        activeTab: [Number, Boolean],
        index: [Number, Boolean],
        slide: {
            type: Object,
            required: true
        },
    },

    computed: {
        attrs() {
            if (this.a11y) {
                const { index, activeTab } = this
                return {
                    role: "tabpanel",
                    "aria-labelledby": `panel-btn-${index}`,
                    "aria-hidden": activeTab !== index ? 'true' : undefined,
                }
            }
            return {}
        },
    },

    methods: {
        slugify( slug ) {
            return adjustSlugFromTitle(slug)
        },
        href(slug, author) {
            const { path } = this.$route
            const storySlug = adjustSlugFromTitle(slug)
            const adjustedSlug = adjustStorySlugByPath(storySlug, path)

            if ( adjustedSlug.includes('create-your-own')) {
                return adjustedSlug
            }

            return `${adjustedSlug}-${author.toLowerCase().replace('_', '-')}`
        },
    },
}
</script>

<style lang="scss" scoped>
.tabs-card {
    position: relative;
}
.tabs-card__cover {
    background: var(--purple);
    @media (width <= 1280px) {
        border-radius: 1rem;
        margin-bottom: 30px;
        aspect-ratio: 16 / 9;
        display: block;
    }
    @media (width > 1280px) {
        position: absolute;
        object-position: right;
        top: 0; right: 0;
        width: 60%;
        height: 100%;
    }
    @media (width > 1680px) {
        width: 75%;
    }
}

.tabs-card__img {
    opacity: .9;
    height: 100%;
    width: 100%;
    object: {
        fit: cover;
        position: center;
    }
    @media (width <= 1280px) {
        border-radius: 1rem;
    }
}

.tabs-card__text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-block-end: 6px;
    gap: 20px;
    position: inherit;
    z-index: 1;

    .more__label {
        text-transform: uppercase;
        letter-spacing: 0.075em;
    }

    .title {
        line-height: 1.25;
    }

    @media (width > 1280px) {
        --inside: 3rem;
        gap: 30px;
        height: 100%;
        width: var(--mw, 65%);
        padding-block: var(--inside);
        padding-inline: var(--inside) calc(var(--inside) / 1.5);
        background: #fff;
        border-radius: 0 0 10em 0;

        .title {
            margin-bottom: 1em;
        }
    }
    @media (width > 1366px) {
        --inside: 4rem;
    }
    @media (width > 1680px) and (height > 900px) {
        --inside: 5rem;
        --mw: 45%;
    }
}
.more--slide {
    position: static;
    margin-top: auto;
    display: flex;
    gap: 1.25em;
    background: #fff;
    box-shadow: 0 0 0 6px #fff;
    border-radius: 5em;

    --more-size: 32px;
    --more-size-x: 14px;
    --more-fs: 80%;

    > :first-child {
        color: var(--purple);
        font-size: var(--more-fs);
        font-weight: 600;
        flex-shrink: 0;
    }

    @media (width > 1280px) {
        --more-size: 40px;
        --more-size-x: 16px;
        --more-fs: 95%;
    }
}
</style>